module.exports = __webpack_public_path__ + "static/media/btn_shroom.f54e7e8e.png";